import { track } from '@vfde-fe/sails_core';
import {
    GET_OVERLAY_CONTENT_FAILED, OVERLAY_LOADED, PRELOAD_GIGAKOMBI_OVERLAY,
    TRACK_OVERLAY,
} from './constant';

/** Getting the content of the overlay failed
 *
 * @param error
 * @returns { Array } - Action of type GET_OVERLAY_CONTENT_FAILED
 */
export function getOverlayContentFailed (error) {

    return {
        type: GET_OVERLAY_CONTENT_FAILED,
        error,
    };
}

/**
 * trackOverlay
 * @param newState
 */

export function trackOverlay (newState) {
    const { overlayState, overlayName } = newState;
    const action = overlayState ? 'show' : 'close';

    return track({
            type: TRACK_OVERLAY,
        },
        'layover',
        {
            action,
            name: overlayName,
        },
    );
}

/**
 * setOverlayMounted
 */
export const preloadGigaKombiOverlay = (contentTarget, scriptTarget) => ({
    type: PRELOAD_GIGAKOMBI_OVERLAY,
    contentTarget,
    scriptTarget,
});

/**
 * setOverlayMounted
 */
export const overlayLoaded = () => ({
    type: OVERLAY_LOADED,
});
